import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import MarketingLayout from "@/components/marketing/MarketingLayout"
import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"

export default function Customers() {
  const { t } = useTranslation()
  const stories = t("pages.customers.stories", { returnObjects: true, defaultValue: [] })
  const list = Array.isArray(stories) ? stories : []

  return (
    <MarketingLayout seoKey="customers">
      <div className="pt-36 pb-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-5">
            {t("pages.customers.eyebrow")}
          </p>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-medium">{t("pages.customers.title")}</h1>
          <p className="mt-6 text-lg text-muted-foreground">{t("pages.customers.subtitle")}</p>
        </div>

        <div className="mx-auto max-w-5xl px-6 lg:px-10 mt-16 space-y-16">
          {list.length === 0 ? (
            <p className="text-muted-foreground border-t border-border pt-12">{t("pages.customers.empty")}</p>
          ) : (
            list.map((story) => (
              <blockquote key={`${story.author}-${story.quote?.slice(0, 24)}`} className="border-t border-border pt-12">
                <p className="font-display text-2xl md:text-3xl tracking-tighter leading-snug">"{story.quote}"</p>
                <footer className="mt-6 flex items-center gap-4">
                  <div className="h-12 w-12 rounded-full bg-secondary grid place-items-center font-display font-medium text-sm">
                    {story.initials}
                  </div>
                  <div>
                    <p className="font-medium">{story.author}</p>
                    <p className="text-sm text-muted-foreground">{story.role}</p>
                  </div>
                </footer>
              </blockquote>
            ))
          )}
        </div>

        <div className="mx-auto max-w-3xl px-6 lg:px-10 mt-20 text-center">
          <Link to="/signup">
            <Button size="lg" className="rounded-full">
              {t("common.startFreeTrial")} <ArrowRight strokeWidth={1.5} className="ml-1 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </MarketingLayout>
  )
}
